import React from 'react';

import Button from '@atlaskit/button/button';

const ButtonPrimaryExample = (): React.JSX.Element => {
	return <Button appearance="primary">Primary button</Button>;
};

export default ButtonPrimaryExample;
